import { useEffect, useState } from "react";

const DevDebugPanel = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === "d") {
        event.preventDefault();
        setIsOpen((prev) => !prev);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  if (!isOpen || import.meta.env.MODE !== "development") {
    return null;
  }

  const userInfo = (() => {
    if (typeof window === "undefined") return {};
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  })();

  const apiUrl =
    import.meta.env.VITE_API_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    "Not set";

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] h-1/3 overflow-auto bg-gray-900 p-4 text-sm font-mono text-white">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-bold text-yellow-400">Dev Debug Panel</h3>
        <button
          onClick={() => setIsOpen(false)}
          className="text-gray-400 transition-colors hover:text-white"
        >
          Close (Ctrl+Shift+D)
        </button>
      </div>
      <div className="space-y-1">
        <p>
          <span className="text-green-400">Environment:</span>{" "}
          {import.meta.env.MODE}
        </p>
        <p>
          <span className="text-green-400">API URL:</span> {apiUrl}
        </p>
        <p>
          <span className="text-green-400">User ID:</span>{" "}
          {userInfo?.id || "Not Logged In"}
        </p>
        <p>
          <span className="text-green-400">User Role:</span>{" "}
          {userInfo?.role || "N/A"}
        </p>
      </div>
    </div>
  );
};

export default DevDebugPanel;
